
// Action Types
import {createAction, handleActions} from "redux-actions";

const SET_PAGE = 'auth/SET_PAGE';
const SET_AGREE = 'auth/SET_AGREE';
const SET_AGREE_ALL = 'auth/SET_AGREE_ALL';
const SET_DISAGREE_ALL = 'auth/SET_DISAGREE_ALL';
const SET_AGREE_OPTIONAL = 'auth/SET_AGREE_OPTIONAL';
const SET_AGREE_OPTIONAL_ALL = 'auth/SET_AGREE_OPTIONAL_ALL';
const SET_DISAGREE_OPTIONAL_ALL = 'auth/SET_DISAGREE_OPTIONAL_ALL';

const SET_KKO_DATA = 'auth/SET_KKO_DATA';
const SET_NO_ACCESS = 'auth/SET_NO_ACCESS';

const SET_MAINCATE = "register/SET_MAINCATE";
const SET_MIDCATE = "register/SET_MIDCATE";
const SET_SUBCATE = "register/SET_SUBCATE";


// Action Creators
export const setPage = createAction(SET_PAGE);
export const setAgree = createAction(SET_AGREE);
export const setAgreeAll = createAction(SET_AGREE_ALL);
export const setDisagreeAll = createAction(SET_DISAGREE_ALL);
export const setAgreeOptional = createAction(SET_AGREE_OPTIONAL);
export const setAgreeOptionalAll = createAction(SET_AGREE_OPTIONAL_ALL);
export const setDisagreeOptionalAll = createAction(SET_DISAGREE_OPTIONAL_ALL);

export const setKkoData = createAction(SET_KKO_DATA);
export const setNoAccess = createAction(SET_NO_ACCESS);

export const setMainCateList = createAction(SET_MAINCATE);
export const setMidCateList = createAction(SET_MIDCATE);
export const setSubCateList = createAction(SET_SUBCATE);

const initialState ={
    whatpage: 1,
    agree: {
        service: false,
        personal: false,
        spam: false,
    },
    agreeOptional: {
        recvMms: false,
        recvMail: false,
        recvKakao: false,
    },
    noAccess12: false,
    noAccess1: false,
    kkoSyncData: null,

    mainCategories: [],
    midCategories: [],
    subCategories: []
};

// Reducer
export default handleActions(
    {
        [SET_PAGE]: (state, action) => ({ ...state, whatpage: action.payload }),
        [SET_AGREE]: (state, action) => ({
            ...state,
            agree: { ...state.agree, ...action.payload }
        }),
        [SET_AGREE_ALL]: (state) => ({
            ...state,
            agree: {
                service: true,
                personal: true,
                spam: true,
            },
            agreeOptional: {
                recvMms: true,
                recvMail: true,
                recvKakao: true,
            },
        }),
        [SET_DISAGREE_ALL]: (state) => ({
            ...state,
            agree: {
                service: false,
                personal: false,
                spam: false,
            },
            agreeOptional: {
                recvMms: false,
                recvMail: false,
                recvKakao: false,
            },
        }),

        [SET_AGREE_OPTIONAL]: (state, action) => ({
            ...state,
            agreeOptional: { ...state.agreeOptional, ...action.payload }
        }),
        [SET_AGREE_OPTIONAL_ALL]: (state, action) => ({
            ...state,
            agreeOptional: {
                recvMms: true,
                recvMail: true,
                recvKakao: true,
            },
        }),
        [SET_DISAGREE_OPTIONAL_ALL]: (state, action) => ({
            ...state,
            agreeOptional: {
                recvMms: false,
                recvMail: false,
                recvKakao: false,
            },
        }),


        [SET_KKO_DATA]: (state, action) => ({
            ...state,
            kkoSyncData: action.payload,
            noAccess1: true,
            whatpage: 2
        }),
        [SET_NO_ACCESS]: (state, action) => ({
            ...state,
            [action.payload]: true
        }),
        [SET_MAINCATE]: (state, action) => ({
            ...state,
            mainCategories: action.payload
        }),
        [SET_MIDCATE]: (state, action) => ({
            ...state,
            midCategories: action.payload
        }),
        [SET_SUBCATE]: (state, action) => ({
            ...state,
            subCategories: action.payload
        })
    },
    initialState
);
